module.exports = __webpack_public_path__ + "img/virtualclass.0e0e2f0e.png";